module.exports = __webpack_public_path__ + "static/media/backWave10.29e68a46.svg";